import { render, staticRenderFns } from "./ArvoreSubPastas.vue?vue&type=template&id=47347822"
import script from "./ArvoreSubPastas.vue?vue&type=script&lang=js"
export * from "./ArvoreSubPastas.vue?vue&type=script&lang=js"
import style0 from "./ArvoreSubPastas.vue?vue&type=style&index=0&id=47347822&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports